import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none" fillRule="evenodd">
      <path fill="#00BFB3" d="M16,0 C13.082,0 10.355,0.794 8,2.158 C12.777,4.926 16,10.081 16,16 C16,21.919 12.777,27.074 8,29.842 C10.355,31.206 13.082,32 16,32 C24.837,32 32,24.837 32,16 C32,7.163 24.837,0 16,0"/>
      <path fill="#FEC514" d="M8,24 L10.222,24 C11.988,21.744 13,18.935 13,16 C13,13.065 11.988,10.256 10.222,8 L8,8 C3.582,8 0,11.582 0,16 C0,20.418 3.582,24 8,24"/>
      <path className="euiIcon__fillNegative" d="M16,8 L13.848,8 C15.214,10.353 16,13.082 16,16 C16,18.918 15.214,21.647 13.848,24 L16,24 C20.418,24 24,20.418 24,16 C24,11.582 20.418,8 16,8"/>
    </g>
  </svg>
);
